import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {LoadBlockedCountires} from './blocked-countries.actions';
import {Observable, tap} from 'rxjs';
import {OttEventService} from '@tisa-group/core';

export type BlockedCountiresStateModel = boolean | null;

@State<BlockedCountiresStateModel>({
  name: 'BlockedCountires',
  defaults: null,
})
@Injectable()
export class BlockedCountiresState {
  @Action(LoadBlockedCountires)
  loadBlockedCountires(
    ctx: StateContext<BlockedCountiresStateModel>,
    action: LoadBlockedCountires,
  ): Observable<boolean> | boolean {
    const stateBlockedCountires = ctx.getState();

    if (stateBlockedCountires) {
      return stateBlockedCountires;
    }

    return this.eventService.isAllowedCountry().pipe(tap(res => ctx.setState(!res)));
  }

  @Selector()
  static isInBlockedCountry(state: BlockedCountiresStateModel): boolean {
    return !!state;
  }

  constructor(readonly eventService: OttEventService) {}
}
